import styled from "styled-components";

export const Container = styled.section`
	@media screen and (min-width: 0px) {
		/* min-height: calc(100vh - 90px); */
		flex: 1 1 auto;
		padding: 0 1em;
		background-color: var(--primary-color);

		display: flex;
		flex-direction: column;

		header.header {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: space-between;
			margin-top: 1em;

			h2 {
				font-size: 0.875em;
				color: var(--white);
				margin: 0;
				text-transform: uppercase;
				margin-bottom: 10px;

				button {
					position: relative;
					background-color: #419cfb;
					border-radius: 50%;
					width: 25px;
					height: 25px;
					display: inline-flex;
					align-items: center;
					justify-content: center;
					text-decoration: none;
					outline: none;
					box-shadow: none;
					border: 0;
					margin-left: 5px;

					&:hover {
						&::after {
							/* display: none; */
							position: absolute;
							top: 30px;
							left: 0px;
							display: block;
							content: "Para validação do cupom, a Loja Participante avaliará os dados do código apresentado, sendo a data do Cupom e dados do Cliente/Tutor. Após essa validação, será concedido ao Cliente/Tutor um desconto financeiro de 30% na compra do Gerioox 30.";
							background-color: var(--white);
							color: var(--auxiliary-color);
							z-index: 20000;
							padding: 0.8em;
							border-radius: 4px;
							width: 150px;
							font-size: 1em;
							text-align: left;
							box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.1);
						}
					}
				}
			}

			button {
				background: none;
				border: none;
				font-size: 0.875em;
				font-weight: 600;
				color: var(--white);
				text-decoration: underline;
				padding: 0;
			}

			.legend {
				background-color: #fff;
				padding: 10px;
				border-radius: 4px;
				display: flex;
				flex-direction: column;

				div {
					button {
						position: relative;
						background-color: #419cfb;
						border-radius: 50%;
						width: 25px;
						height: 25px;
						display: inline-flex;
						align-items: center;
						justify-content: center;
						text-decoration: none;
						outline: none;
						box-shadow: none;
						border: 0;
						margin-left: 5px;

						&:hover {
							&::after {
								/* display: none; */
								position: absolute;
								top: 30px;
								left: 50%;
								transform: translateX(-50%);
								display: block;
								content: "cupom não bonificado para o lojista.";
								background-color: var(--white);
								color: var(--auxiliary-color);
								z-index: 20000;
								padding: 0.8em;
								border-radius: 4px;
								width: 200px;
								font-size: 1em;
								text-align: left;
								box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.1);
							}
						}
					}
				}

				div:nth-of-type(2) {
					margin-top: 10px;

					button {
						&:hover {
							&::after {
								content: "cupom já bonificado para o lojista.";
							}
						}
					}
				}
			}
		}

		.load-msg {
			color: var(--white);
		}

		.cupons {
			padding: 0;
			display: flex;
			flex-direction: column;
			justify-content: center;
			row-gap: 1em;

			li {
				background-color: var(--white);
				padding: 1em;
				border-radius: 8px;
				display: flex;
				flex-direction: column;
				box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.1);
				margin: 5px 0;

				p {
					margin: 2px 0;
				}

				header {
					display: flex;
					justify-content: space-between;
					align-items: center;

					.cupomDate {
						text-align: right;
					}
				}

				.cupomInfo {
					display: flex;
					justify-content: space-between;
					align-items: flex-end;

					.persona {
						.status {
							display: flex;
							align-items: center;

							svg {
								margin-right: 5px;
							}
						}
					}

					.action {
						button {
							background: none;
							border: none;
							outline: none;
						}
					}
				}
			}
		}

		.load-data {
			background: none;
			border: none;
			outline: none;
			font-size: 0.875em;
			color: var(--white);
			text-transform: uppercase;
			text-decoration: underline;
			width: fit-content;
			width: 180px;
			margin: 0 auto;
			margin-bottom: 15px;
			padding: 15px;
		}

		.modal {
			background-color: var(--white);
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			padding: 2em 1em;
			z-index: 2000;
			overflow-y: auto;

			.content {
				max-width: 567px;
				box-shadow: 0px 0px 9px 3px rgba(0, 0, 0, 0.1);
				margin: 5px;
				border-radius: 8px;
				border-bottom-right-radius: 0px;
				background-color: var(--white);
				background-image: url(${require("@/assets/img/labyes.png")
					.default});
				background-repeat: no-repeat;
				background-position: right bottom;
				position: relative;

				display: flex;
				flex-direction: column;
				padding: 1em;
				padding-bottom: 5em;

				.close {
					cursor: pointer;
					position: absolute;
					top: 1em;
					right: 1em;
					z-index: 1000;
				}

				h2 {
					font-size: 1.125em;
					margin-bottom: 5px;
				}

				.form {
					input {
						width: 85%;
						height: 40px;
						border: 0;
						border-bottom: 1px solid #333;
						text-align: left;
					}
				}

				.months {
					&__list {
						display: flex;
						flex-wrap: wrap;
						margin-top: 15px;

						button {
							width: 80px;
							height: 40px;
							padding: 0;
							font-size: 0.875em;
							background-color: var(--white);
							border: 1px solid #707070;
							outline: none;
							margin-right: 5px;
							margin-top: 5px;

							&.active {
								background-color: var(--primary-color);
								color: var(--white);
								border-color: transparent;
							}
						}
					}
				}

				.years {
					&__list {
						display: flex;
						flex-wrap: wrap;
						margin-top: 15px;

						button {
							width: 80px;
							height: 40px;
							padding: 0;
							font-size: 0.875em;
							background-color: var(--white);
							border: 1px solid #707070;
							outline: none;
							margin-right: 5px;
							margin-top: 5px;

							&.active {
								background-color: var(--primary-color);
								color: var(--white);
								border-color: transparent;
							}
						}
					}
				}

				.btn-secundary {
					min-width: 218px;
					margin: 1em 0;
					outline: none;
				}

				.clear {
					background: none;
					padding: 0;
					width: max-content;
					display: block;
					border: 0;
					font-size: 1em;
					font-weight: 600;
					color: var(--secundary-color);
					text-decoration: underline;
					padding: 0;
					outline: none;
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		/* background-image: url(${require("@/assets/img/labyes.png")
			.default});
		background-repeat: no-repeat;
		background-position: right bottom; */

		header.header {
			flex-direction: row;
			align-items: center;
			padding: 0 5.3vw;
			margin-bottom: 15px;

			h2 {
				font-size: 1em;
				margin-bottom: 0;

				button {
					&:hover {
						&::after {
							width: 300px;
							font-size: 0.8em;
						}
					}
				}
			}

			button {
				font-size: 1.12em;
			}

			.legend {
				flex-direction: row;

				div {
					button {
						&:hover {
							&::after {
								width: 300px;
								left: auto;
								right: 0;
								transform: translateX(0);
							}
						}
					}
				}

				div:nth-of-type(2) {
					margin-top: 0;
					margin-left: 15px;
				}
			}
		}

		.cupons {
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: space-evenly;

			li {
				min-width: 345px;
				max-width: 345px;

				& > header {
					.cupomDate {
						strong {
							font-size: 0.875em;
						}
					}
				}

				p {
					font-size: 1em;
				}
			}
		}

		.modal {
			background-color: rgba(0, 0, 0, 0.9);

			.content {
				position: relative;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}
`;
